<template>
    <section  style="background-color:white;width: 100%;z-index: 99;position: relative;">
        <div class="max-width-header">  
        
            <v-btn  icon elevation="0" class="d-flex  align-self-center  validate-tramites-mobile" @click="showValidate()" color="transparent" >
                <v-icon
                left
                color="black"
                class="pl-5"
                >
                    {{icon}}
                </v-icon>
            </v-btn>
            <v-card flat class="d-flex flex-row   mobile-header-logo" max-width="100%" color="#FF8400" >
                <v-card color="#FF8400" flat tile  class="flex-fill">
                    <router-link to="/">
                        <v-img
                        class="ml-16 my-3 mr-3 mobile-header-logo"
                        lazy-src="../../assets/img/logo_genl_blanco.png"
                        max-height="50"
                        max-width="125"
                        src="../../assets/img/logo_genl_blanco.png"
                        ></v-img>
                    </router-link>
                </v-card>
                <v-card flat class="d-flex  align-self-center  position-mobile"  color="transparent" >
                    <!-- <h1 class="align-self-center montserrat mobile-header-text" >SERVICIOS DE FACTURACIÓN</h1>            -->
                    <v-btn class="px-10  white--text  mobile-header-button" @click="goLogin()" :color="colorBtn" >
                        Entrar
                    </v-btn>
                </v-card>
            </v-card>

        </div>
         <transition name="fade">
            <div v-if="icon == 'fas fa-times'" style="height:100%; width: 100% ">
                <v-card
                    class="mobile-status-background d-flex flex-column w-100"
                    :color="colorConsultarBackground"
                    flat
                    tile
                    style="z-index: 3"
                >
                    <v-card
                    v-for="(item, index) in itemsConsultar"
                    :key="index"
                    class="align-self-center d-flex d-flex flex-column"
                    :color="colorConsultarBackground"
                    flat
                    width="100%"
                    >
                        <v-card  style="width:100%" flat :color="colorConsultarBackground">

                            <v-btn class="py-6 mobile-status-btn bttn-consulta" @click="goValidate(item.text)" color="transparent"    depressed tile style="width:100%;border-bottom:thin solid Currentcolor !important" >
                                <v-card tile plain flat class="text-decoration-none  text-none  mobile-status-text bttn-consulta text-wrap"   color="transparent">
                                {{item.text}}
                                </v-card>
                            </v-btn> 
                        </v-card> 
                    </v-card>
                </v-card>
            </div>
         </transition>
    </section>
</template>

<script>
export default {
    data(){
        return{
            title:[
                ''
            ],
            color: 'white',
            colorConsultarBackground: '#fff5d3',
            colorBtn: '#001b2b', 
            icon:'fas fa-bars',
            itemsConsultar:[
                {text: 'Consulta la validez de tu documento' , textBtn: 'Aquí' },
                {text: 'Consulta el estatus de pago de tu trámite', textBtn: 'Aquí' }
            ],
        }
    },
    methods:{
        goLogin(){
            this.$router.push({name: 'login'})
        },
        showValidate(){
            this.icon == 'fas fa-bars' ? this.icon = 'fas fa-times' : this.icon = 'fas fa-bars' 
        },
        goValidate(item){
            console.log(item);
            if(item == "Consulta la validez de tu documento"){
                this.$router.push({name: 'documents_validate'})

            }else{
                this.$router.push({name: 'paid_validate'})

            }
            this.$forceUpdate();
        },
    }
}
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    }
    .mobile-status-background{
        height: 100% !important;
    }
    .bttn-consulta{
        color : #ff8400 !important;
    }
    .mobile-status-btn{
        font-size: 10px;
        width: 100%;
    }
    .validate-tramites-mobile{
        position: absolute;
        margin-top: 10px;
        z-index: 9;
        display: none !important;
        transition: 1s ease-in-out;

    }
@media only screen and (max-width: 1000px) {

    .validate-tramites-mobile{
        display: inline-block !important;
        transition: 1s ease-in-out;
    }
    
    .hide-mobile{
        display: none !important;
    }

    .position-mobile{
        position: absolute;
        /* right:-100px */
        right: 0  ;
        padding-right: 10px;
    }
    .mobile-header-logo{
        justify-content: center !important;
        padding: unset  !important;
        margin-left:  auto !important;
        margin-right:  auto !important;
    }

    .mobile-header-text{
        font-size: 11px !important;
        padding: 0 16px;
        line-height: 1rem;
        padding-top: 2px  !important;
        padding-bottom: 2px !important;
        padding-right: 10px !important;
        padding-left: 10px !important;
    }
    .mobile-header-button{
        font-size: 10px !important;
        padding-top: 2px  !important;
        padding-bottom: 2px !important;
        padding-right: 2px !important;
        padding-left: 2px !important;
    }

}

@media screen and (min-width: 1600px) {
    .max-width-header{
        width: 1500px;
        margin-left: auto;
        margin-right: auto;
    }
}
</style>
